export default function splitString (input = '', length = 4) {
  const pattern = `.{1,${length}}`
  const regex = new RegExp(pattern, 'g')
  return input.match(regex).join(' ')
}
